import { merge } from 'lodash-es';

// @cpt-algo:cpt-pstorageuihci-algo-common-pinia-store-pagination:p1
export const applyPagingParams = {
  // @cpt-begin:cpt-pstorageuihci-algo-common-pinia-store-pagination:p1:inst-common-params
  common: (requestParams: Record<string, unknown>, { marker, limit }: { marker: ID | undefined; limit: number }) => ({
    limit,
    marker,
    with_count: true,
    ...requestParams,
  }),
  // @cpt-end:cpt-pstorageuihci-algo-common-pinia-store-pagination:p1:inst-common-params
  // @cpt-begin:cpt-pstorageuihci-algo-common-pinia-store-pagination:p1:inst-s3-params
  s3: (requestParams: Record<string, unknown>, { marker, limit }: { marker: ID | undefined; limit: number }) => merge({}, requestParams, {
    params: {
      marker,
      count: limit
    }
  }),
  // @cpt-end:cpt-pstorageuihci-algo-common-pinia-store-pagination:p1:inst-s3-params
};

export const getNextMarker = {
  // @cpt-begin:cpt-pstorageuihci-algo-common-pinia-store-pagination:p1:inst-common-marker
  common: (response: FetchResponse): ID => response.data.pages?.find((cursor) => cursor.rel === 'next')?.marker,
  // @cpt-end:cpt-pstorageuihci-algo-common-pinia-store-pagination:p1:inst-common-marker
  // @cpt-begin:cpt-pstorageuihci-algo-common-pinia-store-pagination:p1:inst-s3-marker
  s3: (response: FetchResponse): ID => response.data.next_marker,
  // @cpt-end:cpt-pstorageuihci-algo-common-pinia-store-pagination:p1:inst-s3-marker
};

export const isPageLast = {
  // @cpt-begin:cpt-pstorageuihci-algo-common-pinia-store-pagination:p1:inst-common-last
  common: (response: FetchResponse, nextMarker: ID | undefined, items: unknown[], limit: number): boolean => !nextMarker || items.length < limit,
  // @cpt-end:cpt-pstorageuihci-algo-common-pinia-store-pagination:p1:inst-common-last
  // @cpt-begin:cpt-pstorageuihci-algo-common-pinia-store-pagination:p1:inst-s3-last
  s3: (response: FetchResponse, nextMarker: ID | undefined): boolean => !response.data.is_truncated || !nextMarker,
  // @cpt-end:cpt-pstorageuihci-algo-common-pinia-store-pagination:p1:inst-s3-last
};
